import type { FaireProductEntity } from "../../entity_types/product";

export const p_bd6q2etg95: FaireProductEntity = {
  token: "p_bd6q2etg95",
  type: "product",
  name: "100g Bag First Flush Ceremonial Matcha",
  brandToken: "b_4fvfm8f5",
  brandName: "DONA",
  imageUrl:
    "https://cdn.faire.com/fastly/9fc80bc3bf2619af14578ed5290d6e5287f36239c39c42ce6d74d273670d6f4a.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/84a2d50464e1da9186b6bcc441a74d7d07f5fc27e60c6895001ff1e5065139e3.webp",
    "https://cdn.faire.com/fastly/362e07d47a15388738753a48d8c86979609507d8c2cc82906e3d992a44ae8a90.webp",
    "https://cdn.faire.com/fastly/c9ec5ac72594d5a66bcd84c61cb4bb63d23dbe7286cff73008f6e653442260f8.webp",
  ],
  priceDollars: 50,
  description:
    "First Flush Ceremonial Matcha. This matcha comes from several small producers in Japan, all dedicated to their craft. We select each matcha based on their similar flavor profiles: fresh, smooth, and toasty matcha with a clean finish. The matcha is hand-plucked, traditionally stone-milled, and air-freighted to ensure optimal freshness. \n\nWhat is first flush? First flush marks the first harvest of tea leaves in early spring, when tea bushes awaken from winter slumber. During the colder months, growth slows while flavor and sugars develops within young, tender leaves. The first flush pluck yields vibrant green matcha with exceptional smoothness and depth, making it the ideal harvest for ceremonial grade.\n\nOrigin: Kagoshima, Kyoto & Shizuoka, Japan.",
  tags: [],
  msrpDollars: 100,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-31T17:20:42.005Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
